import { getLogoutEndpoint } from "./SubdomainEndpoint";
import superagent from 'superagent'

export async function logoutAtSubdomain() {
    try {
        await superagent.post(getLogoutEndpoint()).send().withCredentials()
    } catch(e) {
        return;
    }
}